import { ReportsModal, DynamicModal, PrintMapModal } from './components';
import * as sagas from './sagas';
import * as reducers from './reducers';

const modals = {
  REPORTS: {
    id: 'REPORTS',
    component: ReportsModal,
    onOpen: ({ data }) => ({
      type: 'OPEN_PARCEL_REPORT',
      payload: data,
    }),
  },
  PARCEL: {
    id: 'PARCEL',
    component: DynamicModal,
    onOpen: ({ data }) => ({
      type: 'FETCH_PARCEL_FOR_REPORT',
      payload: data,
    }),
  },
  PARCEL_PRELOADED: {
    id: 'PARCEL_PRELOADED',
    component: DynamicModal,
  },
  MULTI_PARCEL: {
    id: 'MULTI_PARCEL',
    component: DynamicModal,
    onOpen: ({ data }) => ({
      type: 'FETCH_MULTI_PARCEL_REPORT',
      payload: data,
    }),
  },
  PRINT_MAP: {
    id: 'PRINT_MAP',
    component: PrintMapModal,
  },
};
export * from './components';

export { modals, reducers, sagas };
